import $ from "jquery";

const EL_BODY = ".page";
const EL_POPPER = ".popper";
const EL_POPPER_BUTTON = ".popper__button";
const EL_POPPER_CONTENT = ".popper__content";
const CL_POPPER_CONTENT_ACTIVE = "popper__content_active";

const $popper = $(EL_POPPER);
const $window = $(window);
const $body = $(EL_BODY);

$(function () {
  if ($popper.length > 0) {
    $popper.each(function index() {
      const $thisEl = $(this);
      popper($thisEl, index);
    });
  }
});

const popper = ($element, index) => {
  const $button = $element.find(EL_POPPER_BUTTON);
  const $content = $element.find(EL_POPPER_CONTENT);

  $button.off("click");
  $body.off(`click.popper${index}`);
  $body.off(`keydown.popper${index}`);
  $window.off(`resize:width.popper${index}`);

  $button.on("click", (event) => {
    event.stopPropagation();
    toggle($content);
  });

  $body.on(`click.popper${index}`, () => hide($content));
  $body.on(`keydown.popper${index}`, function (event) {
    if (event.key === "Escape") {
      hide($content);
    }
  });
  $window.on(`resize:width.popper${index}`, () => hide($content));
};

const toggle = ($element) => {
  $element.hasClass(CL_POPPER_CONTENT_ACTIVE) ? hide($element) : show($element);
};

const hide = ($element) => {
  $element.removeClass(CL_POPPER_CONTENT_ACTIVE);
};
const show = ($element) => {
  $element.addClass(CL_POPPER_CONTENT_ACTIVE);
};
